<p-toast />
<app-container-manager-login title="Redefinir Senha">
  <form class="p-fluid" autocomplete="off" [formGroup]="form" (submit)="onSubmit()">
    <div class="p-field p-mb-3">
      <label for="senha" class="p-mb-2 block">Nova Senha</label>
      <p-password id="senha" formControlName="senha" placeholder="Digite sua nova senha" [toggleMask]="true"
        [feedback]="false" styleClass="w-full" inputStyleClass="w-full"></p-password>
      <div *ngIf="senha?.dirty" class="p-mt-2">
        <small class="p-error p-d-block" *ngIf="!senha?.value?.match('^(?=.*[A-Z])')">• Pelo menos uma letra
          maiúscula</small>
        <small class="p-error p-d-block" *ngIf="!senha?.value?.match('(?=.*[a-z])')">• Pelo menos uma letra
          minúscula</small>
        <small class="p-error p-d-block" *ngIf="!senha?.value?.match('(.*[0-9].*)')">• Pelo menos um dígito</small>
        <small class="p-error p-d-block" *ngIf="!senha?.value?.match('(?=.*[!@#$%^&*])')">• Pelo menos um caractere
          especial</small>
        <small class="p-error p-d-block" *ngIf="!senha?.value?.match('.{8,}')">• Mínimo de 8 caracteres</small>
      </div>
    </div>
    <div class="p-field p-mb-3">
      <label for="confirmarSenha" class="p-mb-2 block">Confirmar Senha</label>
      <p-password id="confirmarSenha" formControlName="confirmarSenha" placeholder="Digite novamente sua senha"
        [toggleMask]="true" [feedback]="false" styleClass="w-full" inputStyleClass="w-full"></p-password>
      <small class="p-error p-d-block p-mt-2"
        *ngIf="form.errors?.['confirmedValidator'] && (form.get('confirmarSenha')?.touched || form.get('confirmarSenha')?.dirty)">
        {{form.errors?.['confirmedValidator']}}
      </small>
    </div>
    <div class="p-field p-mb-3">
      <button pButton type="submit" [disabled]="form.invalid || loadding" [label]="loadding ? '' : 'Redefinir senha'"
        class="p-button-primary w-full p-d-flex p-jc-center p-ai-center">
        <i class="pi pi-spin pi-spinner" *ngIf="loadding"></i>
      </button>
    </div>

    <div class="p-text-center">
      <a [routerLink]="['/login']" class="p-link auth-link">
        Voltar ao login
      </a>
    </div>
  </form>
</app-container-manager-login>